module.exports = __webpack_public_path__ + "static/12-amason-e9308ad9152f5f7b146525ac5a87502e.jpg";